<template>
  <TransitionRoot appear :show="store.freeLimitHit" as="template">
    <Dialog as="div" class="relative z-50" @close="closeModal">
      <div class="fixed inset-0 bg-black/30" />
      <div class="fixed inset-0 overflow-y-auto">
        <div class="flex min-h-full items-center justify-center p-4">
          <DialogPanel class="w-full max-w-md transform overflow-hidden rounded-2xl bg-white p-6 text-left align-middle shadow-xl transition-all">
            <div class="absolute top-4 right-4">
              <button
                type="button"
                class="text-gray-400 hover:text-gray-500 focus:outline-none"
                @click="closeModal"
              >
                <span class="sr-only">Close</span>
                <svg class="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor">
                  <path stroke-linecap="round" stroke-linejoin="round" d="M6 18L18 6M6 6l12 12" />
                </svg>
              </button>
            </div>
            <DialogTitle as="h3" class="text-2xl font-normal leading-6 text-gray-900 mb-4">
              You've Hit Your Free Limit
            </DialogTitle>
            
            <div class="mt-2">
              <p class="text-base front-thin text-gray-500 mb-2">
                You're currently limited to:
              </p>
              <ul class="list-disc pl-5 mb-3">
                <li>2 watchlists</li>
                <li>3 alerts per watchlist</li>
              </ul>
              
              <p class="text-base front-thin text-gray-500 mb-2">
                <strong>Upgrade now </strong> for <strong>$4.99/month</strong> to unlock:
              </p>
              <ul class="list-disc pl-5">
                <li>Unlimited watchlists</li>
                <li>Unlimited alerts</li>
                <li>Full access to real-time market insights</li>
              </ul>
            </div>

            <div class="mt-6 flex justify-end">
              <a 
                href="https://store.nevua.markets" 
                target="_blank"
                class="inline-flex justify-center rounded-md border border-transparent bg-blue-600 px-4 py-2 text-sm font-medium text-white hover:bg-blue-700 focus:outline-none focus-visible:ring-2 focus-visible:ring-blue-500 focus-visible:ring-offset-2"
                @click="closeModal"
              >
                Take me to the store
              </a>
            </div>
          </DialogPanel>
        </div>
      </div>
    </Dialog>
  </TransitionRoot>
</template>

<script>
import { Dialog, DialogPanel, DialogTitle, TransitionRoot } from '@headlessui/vue'
import { store } from '../store'
import * as Sentry from '@sentry/vue';

export default {
  name: 'SubscriptionLimitModal',
  components: {
    Dialog,
    DialogPanel,
    DialogTitle,
    TransitionRoot
  },
  data() {
    return {
      store
    }
  },
  watch: {
    'store.freeLimitHit'(newValue) {
      if (newValue === true) {
        Sentry.captureMessage(`Payment modal opened: ${store?.id}`, 'info')
      }
    }
  },
  methods: {
    closeModal() {
      this.store.freeLimitHit = false
    }
  }
}
</script> 